//TODO : Refactor after ai
/**
 * Beziehungs-Actions („Team zuordnen“, „Kunde zuordnen“, „Material empfehlen“):
 * eine Auswahl aus der Zielklasse – Mehrfachauswahl, wo die Relation „viele“ ist.
 */

import { useState } from "react";
import { useDatenStore } from "@app/store";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@shared/components/atoms/dialog";
import { Button, Chip } from "@shared/components/widgets/ooux";
import {
  alsListe,
  datensaetze,
  objektKlasse,
  relation,
  type Aktion,
  type Datensatz,
  type ObjektKlasse,
} from "@shared/demo-data/viacid";
import { useTranslation } from "@shared/locales";

interface BeziehungDialogProps {
  klasse: ObjektKlasse;
  aktion: Aktion;
  satz: Datensatz;
  onClose: () => void;
}

export function BeziehungDialog({
  klasse,
  aktion,
  satz,
  onClose,
}: BeziehungDialogProps) {
  const { t } = useTranslation();
  const bestand = useDatenStore((s) => s.bestand);
  const aendern = useDatenStore((s) => s.aendern);
  const rel = aktion.relation ? relation(aktion.relation) : undefined;
  const [auswahl, setAuswahl] = useState<string[]>(() =>
    rel ? alsListe(satz.bezuege[rel.id]) : []
  );

  if (!rel) return null;
  const ziel = objektKlasse(rel.zu);
  const kandidaten = datensaetze(bestand, rel.zu).filter(
    (d) => d.status !== "Ausgelistet"
  );

  const waehlen = (id: string) =>
    setAuswahl((alt) =>
      rel.zuViele
        ? alt.includes(id)
          ? alt.filter((x) => x !== id)
          : [...alt, id]
        : [id]
    );

  const speichern = () => {
    aendern(
      {
        slug: klasse.slug,
        id: satz.id,
        bezuege: { [rel.id]: rel.zuViele ? auswahl : (auswahl[0] ?? "") },
      },
      t("viacid.formular.gespeichert", { aktion: aktion.name })
    );
    onClose();
  };

  return (
    <Dialog open onOpenChange={(offen) => !offen && onClose()}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>{aktion.name}</DialogTitle>
        </DialogHeader>
        <p
          style={{
            font: "var(--t-paragraph-s)",
            color: "var(--text-tertiary)",
            margin: 0,
          }}
        >
          {rel.zuViele
            ? t("viacid.beziehung.mehrere", { plural: ziel?.plural })
            : t("viacid.beziehung.eine", { name: ziel?.name })}
        </p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            maxHeight: 320,
            overflowY: "auto",
          }}
        >
          {kandidaten.map((d) => (
            <Chip
              key={d.id}
              selected={auswahl.includes(d.id)}
              onClick={() => waehlen(d.id)}
            >
              {d.titel}
              {d.untertitel ? ` · ${d.untertitel}` : ""}
            </Chip>
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button variant="outline" color="neutral" onClick={onClose}>
            {t("viacid.abbrechen")}
          </Button>
          <Button onClick={speichern}>{aktion.name}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
